import React, { useState, createContext, useContext, useEffect, useMemo } from 'react';

import { LinkItem } from '@occc/ui-design-system';

export const AppLayoutContext = createContext<{
  breadcrumbLinks: LinkItem[];
  setBreadcrumbLinks: React.Dispatch<React.SetStateAction<LinkItem[]>>;
}>({
  breadcrumbLinks: [],
  setBreadcrumbLinks: () => {},
});

AppLayoutContext.displayName = 'AppLayoutContext';

export const AppLayoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [breadcrumbLinks, setBreadcrumbLinks] = useState<LinkItem[]>([]);
  const value = useMemo(() => {
    return { breadcrumbLinks, setBreadcrumbLinks };
  }, [breadcrumbLinks, setBreadcrumbLinks]);

  return <AppLayoutContext.Provider value={value}>{children}</AppLayoutContext.Provider>;
};

export const useAppLayoutContextConsumer = (links: LinkItem[]) => {
  const { setBreadcrumbLinks } = useContext(AppLayoutContext);

  useEffect(() => {
    setBreadcrumbLinks(links);
  }, [setBreadcrumbLinks, links]);

  useEffect(() => {
    return () => {
      setBreadcrumbLinks([]);
    };
  }, [setBreadcrumbLinks]);
};
